import api from "utils/api";

export const ADMIN_UNREAD_MODULES = {
  CRM: "crm",
  SUPPORT_TICKET: "supportTicket",
  FEEDBACK: "feedback",
  PRODUCT_ENQ: "productEnq",
  SERVICE_REVIEW: "serviceReview",
  TRANSACTION: "transaction",
  DEMO: "demo",
};

export const ADMIN_UNREAD_UPDATED_EVENT = "admin-unread-count-updated";

const LEGACY_UPDATED_EVENTS = {
  [ADMIN_UNREAD_MODULES.CRM]: "crm-new-count-updated",
  [ADMIN_UNREAD_MODULES.SUPPORT_TICKET]: "support-ticket-new-count-updated",
  [ADMIN_UNREAD_MODULES.FEEDBACK]: "feedback-new-count-updated",
  [ADMIN_UNREAD_MODULES.PRODUCT_ENQ]: "product-enq-new-count-updated",
  [ADMIN_UNREAD_MODULES.SERVICE_REVIEW]: "service-review-new-count-updated",
  [ADMIN_UNREAD_MODULES.TRANSACTION]: "transaction-new-count-updated",
  [ADMIN_UNREAD_MODULES.DEMO]: "demo-new-count-updated",
};

export const getAdminUnreadCounts = async (modules = []) => {
  const params = {};

  if (Array.isArray(modules) && modules.length) {
    params.modules = modules.join(",");
  }

  const response = await api.get("/admin-unread/counts", { params });
  return response.data;
};

export const markAdminUnreadSeen = async (module, id) => {
  const response = await api.patch("/admin-unread/mark-seen", { module, id });
  const legacyEvent = LEGACY_UPDATED_EVENTS[module];

  window.dispatchEvent(new Event(ADMIN_UNREAD_UPDATED_EVENT));
  if (legacyEvent) {
    window.dispatchEvent(new Event(legacyEvent));
  }
  window.dispatchEvent(new Event(`${module}-new-count-updated`));
  return response.data;
};
